import React from 'react';
import {
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  FormLabel,
  Checkbox,
} from '@material-ui/core';

const clamp = (value, min, max) => Math.min(max, Math.max(min, Number.parseInt(value, 10) || min));

const ModalPersonalizarTabla = ({
  open,
  onClose,
  configTabla,
  setConfigTabla,
  onInsertar,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      disableRestoreFocus
    >
      <DialogTitle style={{ fontSize: 16, fontWeight: 700 }}>
        Personalizar Tabla
      </DialogTitle>
      <DialogContent dividers>
        <div style={{ display: 'flex', gap: 16, marginBottom: 16 }}>
          <TextField
            label="Filas"
            type="number"
            variant="outlined"
            size="small"
            inputProps={{ min: 1, max: 30 }}
            value={configTabla.filas}
            onChange={(e) =>
              setConfigTabla({
                ...configTabla,
                filas: clamp(e.target.value, 1, 30),
              })
            }
            fullWidth
          />
          <TextField
            label="Columnas"
            type="number"
            variant="outlined"
            size="small"
            inputProps={{ min: 1, max: 10 }}
            value={configTabla.columnas}
            onChange={(e) =>
              setConfigTabla({
                ...configTabla,
                columnas: clamp(e.target.value, 1, 10),
              })
            }
            fullWidth
          />
        </div>

        <FormControl component="fieldset" fullWidth style={{ marginBottom: 12 }}>
          <FormLabel component="legend" style={{ fontSize: 13, marginBottom: 6 }}>
            Formato de bordes:
          </FormLabel>
          <RadioGroup
            value={configTabla.estilo}
            onChange={(e) =>
              setConfigTabla({
                ...configTabla,
                estilo: e.target.value,
              })
            }
          >
            <FormControlLabel
              value="sin-bordes"
              control={<Radio size="small" color="primary" />}
              label="Sin bordes (Transparente / Para firmas y alineación)"
            />
            <FormControlLabel
              value="con-bordes"
              control={<Radio size="small" color="primary" />}
              label="Cuadrícula completa (Bordes en todas las celdas)"
            />
            <FormControlLabel
              value="horizontales"
              control={<Radio size="small" color="primary" />}
              label="Solo líneas horizontales"
            />
          </RadioGroup>
        </FormControl>

        {configTabla.estilo !== 'sin-bordes' && (
          <FormControlLabel
            control={
              <Checkbox
                checked={configTabla.conEncabezado}
                onChange={(e) =>
                  setConfigTabla({
                    ...configTabla,
                    conEncabezado: e.target.checked,
                  })
                }
                color="primary"
                size="small"
              />
            }
            label="Incluir fila de encabezado destacada"
          />
        )}
      </DialogContent>
      <DialogActions style={{ padding: '12px 24px' }}>
        <Button onClick={onClose} color="default">
          Cancelar
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => onInsertar(configTabla)}
        >
          Insertar Tabla
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default React.memo(ModalPersonalizarTabla);
